import type { Issuer } from '@/utils/0x/token-registry.types';

/** Issuer property of a token determines the entity that issued or tokenized the asset */
export enum Issuers {
  CIRCLE = 'circle',
  SUPERSTATE = 'superstate',
  XSTOCKS = 'xstocks',
  ZORA = 'zora',
}

/** Badge label for token issuers displayed in search results and token profiles. */
export const getIssuerBadgeLabel = (issuer?: Issuer): string | undefined => {
  const name = issuer?.name?.toLowerCase();
  switch (name) {
    case Issuers.SUPERSTATE:
      return 'Tokenized by Superstate';
    case Issuers.XSTOCKS:
      return 'Issued by xStocks';
    default:
      return undefined;
  }
};

/**
 * Map a token issuer name to the matcha-api price `source` to prefer for that
 * token. xStocks tokens are quoted on CoinGecko; everything else lets
 * matcha-api pick. Takes the bare name string (rather than the full `Issuer`
 * object) so callers can depend on a stable primitive in memoization keys.
 * Comparison is case-insensitive to match `getIssuerBadgeLabel`.
 */
export const getPriceSourceForIssuer = (issuerName?: string): 'coingecko' | undefined => {
  if (issuerName?.toLowerCase() === Issuers.XSTOCKS) return 'coingecko';
  return undefined;
};
